<div class="flex flex-col min-h-screen">
  <header
    class="flex justify-center"
    [class.main-header--scrolled]="isScrolled"
    [ngClass]="{ 'pt-28.75!': !isInnerPage }"
  >
    <div class="container">
      <app-navbar [isScrolled]="isScrolled" />
    </div>
  </header>

  <main class="grow">
    <router-outlet />
  </main>

  <app-footer />
</div>
